import { AutogenModelOriginDestinationRate, AutogenRowOriginDestinationRate } from "./autogen/AutogenModelOriginDestinationRate";

export class ModelOriginDestinationRate extends AutogenModelOriginDestinationRate<RowOriginDestinationRate> {
	constructor() {
		super(RowOriginDestinationRate);
	}
}

export class RowOriginDestinationRate extends AutogenRowOriginDestinationRate {
}